import { PropsWithChildren } from 'react';

import { PreloaderCut, PreloaderDonut, PreloaderIcon } from './styled';

export type LoaderProps = {
  size?: number;
};

export const Loader = ({ size }: LoaderProps) => (
  <PreloaderIcon size={size}>
    <PreloaderCut size={size}>
      <PreloaderDonut size={size} />
    </PreloaderCut>
  </PreloaderIcon>
);

interface LoaderWrapperProps {
  loading: boolean;
}

export const LoaderWrapper = ({
  children,
  loading,
}: PropsWithChildren<LoaderWrapperProps>) => {
  if (loading) return <Loader />;
  return children;
};
